module.exports = __webpack_public_path__ + "img/brushes-1_jp.bbfeaed.jpg";